import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from "@/components/Header";
import Home from "@/pages/Home";
import About from "@/pages/About";
import CollectionPage from "@/pages/CollectionPage";
import Contact from "@/pages/Contact";
import { Toaster } from "@/components/ui/sonner";

function AnimatedRoutes() {
  const location = useLocation();
  return (
    <main className="w-full page-fade-in" key={location.pathname}>
      <Routes location={location}>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/work/:slug" element={<CollectionPage />} />
        <Route path="/commission" element={<Contact />} />
      </Routes>
    </main>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <div className="min-h-screen">
          <Header />
          <AnimatedRoutes />
        </div>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
